module.exports = __webpack_public_path__ + "static/media/Purugly_gaussian2.3aff9c51.png";